module.exports = __webpack_public_path__ + "img/Jump Casting49.0cf3bc2d.jpg";